import React,{useState} from 'react'
import CollectionMenu from '../components/layout/CollectionMenu';
import Header from '../components/layout/Header';
import SideBar from '../components/layout/SideBar';
import NavbarBox from '../components/layout/NavbarBox';
const Navbar = () => {
    const [sidebar, setSidebar] = useState("disable");
    const [ableClass, setAbleClass] = useState("opacity-0 nonvisible -left-80");

    const sidebarCall = () => {
      if (sidebar === "disable") {
        setSidebar("able");
        setAbleClass("opacity-1 visible left-0");
      } else {
        setSidebar("disable");
        setAbleClass("opacity-0 nonvisible -left-80");
      }
    };

  return (
    <div>
     <Header sidebarCall={sidebarCall} />
     <CollectionMenu />
     <SideBar sidebarCall={sidebarCall} ableClass={ableClass} />
    </div>
  )
}

export default Navbar